module.exports = __webpack_public_path__ + "img/3B.9d4f26b9.jpg";